"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gualdo-tadino": {
    "d00b39af": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "skipSearch": false
    }],
    "mancinelli": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gualdo-tadino"
    }],
    "0d22197f": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2ecd8237": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "skipSearch": false
    }],
    "vaccara": [{
      "hkey": "7e5d3fe6",
      "slug": "palazzo-mancinelli-vaccara",
      "name": "Palazzo Mancinelli-Vaccara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gualdo-tadino"
    }]
  }
};
exports["default"] = _default;